/* tslint:disable */
/* eslint-disable */
/**
 * Agrinorm Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PictureSectionType = {
  PackagingPictures: 'packaging_pictures',
  InnerPictures: 'inner_pictures',
  OverviewPictures: 'overview_pictures',
} as const;

export type PictureSectionType =
  (typeof PictureSectionType)[keyof typeof PictureSectionType];
